import {Proposal} from "../../../types/Proposal";
import FacebookIcon from "@mui/icons-material/Facebook";
import {IconButton, Tooltip} from "@mui/material";
import React, {useMemo, useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {DefaultError} from "@tanstack/query-core";
import {sendToFacebook} from "../../../service/proposal.service";
import {enqueueSnackbar} from "notistack";
import {SxProps} from "@mui/system";
import {useAuthStore} from "../../../store/auth.store";
import {FacebookConnectModal} from "./FacebookConnectModal";

export function FacebookButton({sx, proposal, callback}:{callback:() => void, sx?: SxProps, proposal: Proposal}) {
    const authStore = useAuthStore();
    const [showFacebookTargetModal, setShowFacebookTargetModal] = useState(false);

    const hasFacebookSettings = useMemo(() => {
        return !!authStore.user?.facebookConnected;
    }, [authStore.user?.facebookConnected]);

    const sendToFacebookMutation = useMutation<void, DefaultError, void>({
        mutationFn: () => sendToFacebook(proposal.id)
            .then(r => {
                enqueueSnackbar({variant: "success", message: "Sent"});
                callback();
                return r.data;
            }),
        onError: (error) => {
            enqueueSnackbar({message: "Failed to publish Facebook post: " + error.message, variant: 'error'});
        }
    });

    function performFacebookAction() {
        sendToFacebookMutation.mutate();
    }

    function handleClick() {
        if(!authStore.user) {
            enqueueSnackbar({message: "Current user is not loaded yet", variant: "error"});
            return;
        }
        if(hasFacebookSettings) {
            performFacebookAction();
            return;
        }
        setShowFacebookTargetModal(true);
    }

    const title = !hasFacebookSettings
        ? "Configure your Facebook Page before sending"
        : "Send to Facebook";

    return <>
        <Tooltip sx={sx} title={title}>
            <span>
                <IconButton disabled={sendToFacebookMutation.isPending} onClick={handleClick}>
                    <FacebookIcon color={"primary"}/>
                </IconButton>
            </span>
        </Tooltip>
        {showFacebookTargetModal && authStore.user && <FacebookConnectModal
            onClose={() => setShowFacebookTargetModal(false)}
        />}
    </>;
}
